export default "__VITE_ASSET__4ezM0gnQ__"